// extracted by mini-css-extract-plugin
export var badgeTextContainer = "_52-2";
export var blackBorderOnHover = "_52-7";
export var cell = "_52-6";
export var cellContainer = "_52-3";
export var checked = "_52-8";
export var disabled = "_52-5";
export var featuredIconCellContainer = "_52-9";
export var featuredIconTextContainer = "_52-b";
export var featuredIconWrapper = "_52-a";
export var noBorder = "_52-c";
export var orangeSelectedRow = "_c6-3";
export var overflowableText = "_52-0";
export var overflowableTextContainer = "_52-1";
export var row = "_50-0";
export var rowCheckboxCell = "_52-4";
export var selectableTable = "_c6-2";